<template>
  <div class="payout-to-card-info">
    <div class="payout-to-card-info-row">
      <div class="payout-to-card-info-label">
        {{ $t('payout-to-card-view.payout.created-at') }}
      </div>
      <div class="payout-to-card-info-value">
        {{ payout.transactionDateTime }}
      </div>
    </div>
    <div class="payout-to-card-info-row">
      <div class="payout-to-card-info-label">
        {{ $t('payout-to-card-view.payout.card-number') }}
      </div>
      <div class="payout-to-card-info-value">
        {{ payout.cardNumber }}
      </div>
    </div>
    <div class="payout-to-card-info-row">
      <div class="payout-to-card-info-label">
        {{ $t('payout-to-card-view.payout.amount') }}
      </div>
      <div class="payout-to-card-info-value">
        {{ payout.transactionAmount }} {{ payout.transactionCurrencyPlain }}
      </div>
    </div>
    <div class="payout-to-card-info-row">
      <div class="payout-to-card-info-label">
        {{ $t('payout-to-card-view.payout.commission') }}
      </div>
      <div class="payout-to-card-info-value">
        {{ payout.transactionCommission }} {{ payout.transactionCurrencyPlain }}
      </div>
    </div>
    <div class="payout-to-card-info-row">
      <div class="payout-to-card-info-label">
        {{ $t('payout-to-card-view.payout.currency') }}
      </div>
      <div class="payout-to-card-info-value">
        {{ payout.transactionCurrencyPlain }}
      </div>
    </div>
    <div class="payout-to-card-info-row">
      <div class="payout-to-card-info-label">
        {{ $t('payout-to-card-view.payout.recipient') }}
      </div>
      <div class="payout-to-card-info-value">
        {{ payout.userFullName }}
      </div>
    </div>
    <div class="payout-to-card-info-row">
      <div class="payout-to-card-info-label">
        {{ $t('payout-to-card-view.payout.comment') }}
      </div>
      <div class="payout-to-card-info-value"></div>
    </div>
  </div>
</template>

<script>
import { Transaction } from '@js-app/entities/transaction/Transaction'

export default {
  name: 'BillPaidDetails',
  props: {
    payout: {
      type: Transaction,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@css-app/payout-to-card-details';
</style>
